// Ported from dev-scrips-pm-react src/billing/services/use-refund-reasons.ts (PROD-1119 cross-module closure).
import { useQuery } from '@tanstack/react-query';
import { get } from '@/shared/api/api-client';
import { BILLING_BASE } from '@/shared/api/billing-client';

/**
 * Refund-reason value-set — GET `/Billing/Invoice/GetInvoiceMasterData?type=Refund`.
 *
 * Powers the mandatory "Refund reason" dropdown in the patient-billing
 * refund flow (Flutter `refund_payment_popup.dart:68-93` dispatches
 * `FetchRefundCancellationReasonEvent(searchFor: reason_type_REFUND)`;
 * `reason_type_REFUND == "Refund"`).
 *
 * Wire (verified 2026-06-02 dev curl):
 *
 *   GET /Billing/Invoice/GetInvoiceMasterData?type=Refund
 *       → [{ id, value, type }]            (type is the literal "REFUND")
 *
 * The refund body ships `refundReason: { id, value }` (both fields — NOT
 * free text), so the picker carries the GUID through. This is a static
 * org value-set, so we cache it long.
 */

export interface RefundReason {
  id?: string | null;
  value?: string | null;
  /** The literal "REFUND" (the master-data bucket). */
  type?: string | null;
}

export function useRefundReasons(enabled = true) {
  return useQuery({
    queryKey: ['invoice-master-data', 'Refund'],
    queryFn: ({ signal }) =>
      get<RefundReason[]>(
        `${BILLING_BASE}/Invoice/GetInvoiceMasterData?type=Refund`,
        { signal },
      ),
    enabled,
    // Value-set rarely changes within a session — keep it warm.
    staleTime: 5 * 60 * 1000,
  });
}
